<div class="header-container">
  <div>
    <mat-form-field>
      <mat-label>Search for an ATC code</mat-label>
      <input #atcCodeSearch matInput [formControl]="atcFormControl"
             data-qa="qa-input"
             (input)="onInputChangedFilterData('name')">
    </mat-form-field>
  </div>
  <div class="header-spacer"></div>
  <div>
    <button mat-raised-button color="accent" (click)="openAtcDialog()">
      <mat-icon>add</mat-icon> Add ATC Code
    </button>
  </div>
</div>

<div *ngIf="!atcDataSource" class="center-container">
  <mat-spinner></mat-spinner>
</div>

<div *ngIf="atcDataSource" class="mat-elevation-z8 table-container">
  <table mat-table multiTemplateDataRows [dataSource]="atcDataSource" matSort
         #atcSort="matSort" (matSortChange)="sortData($event)">
    
    <ng-container matColumnDef="icons">
      <th *matHeaderCellDef mat-header-cell></th>
      <td *matCellDef="let row" mat-cell>
        <mat-icon class="table-icon" #editAtcTooltip="matTooltip"
                  matTooltip="EDIT ATC Code" (click)="editEntry($event, row.atcId)">edit
        </mat-icon>
        <mat-icon class="table-icon" #deleteAtcTooltip="matTooltip"
                  matTooltip="DELETE ATC Code" (click)="deleteEntry($event, row.atcId)">
          delete</mat-icon>
      </td>
    </ng-container>
    
    <ng-container matColumnDef="atcId">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> ID</th>
      <td *matCellDef="let row" mat-cell> {{row.atcId}}</td>
    </ng-container>
    
    <ng-container matColumnDef="code">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> Code</th>
      <td *matCellDef="let row" mat-cell> {{row.code}}</td>
    </ng-container>
    
    <ng-container matColumnDef="name">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> Name</th>
      <td *matCellDef="let row" mat-cell> {{row.name}}</td>
    </ng-container>
    
    <ng-container matColumnDef="level">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> Level</th>
      <td *matCellDef="let row" mat-cell> {{row.levelDescription}}</td>
    </ng-container>
    
    <ng-container matColumnDef="source">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> Source</th>
      <td *matCellDef="let row" mat-cell>
        <div class="flex justify-start">
          <app-open-link-as *ngIf="row.source"
                            [icon]="DisplayIcon.ExternalIcon" [url]="row.source"
                            (onClick)="$event.stopPropagation()">
          </app-open-link-as>
          <span>{{row.source}}</span>
        </div>
      </td>
    </ng-container>
    
    <ng-container matColumnDef="expandedDetail">
      <td *matCellDef="let row" mat-cell [attr.colspan]="atcDisplayedColumns.length">
        <div class="row-detail-container"
             [@detailExpand]="row == atcExpandedRow ? 'expanded' : 'collapsed'">
          <b>Created By: </b>{{row.createdBy}}<br>
          <b>Created Date: </b>{{row.created | date: dateTimeFormat}}<br>
          <b>Updated By: </b>{{row.updatedBy}}<br>
          <b>Updated Date: </b>{{row.updated | date: dateTimeFormat}}<br>
        </div>
      </td>
    </ng-container>
    
    <tr mat-header-row *matHeaderRowDef="atcDisplayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: atcDisplayedColumns;" class="row"
        [class.expanded-row]="atcExpandedRow == row"
        (click)="atcExpandedRow = atcExpandedRow === row ? null : row">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>
  
  </table>
  
  <mat-paginator #atcPaginator (page)="pageChanged($event)"
                 [length]="atcTableControl.length" [pageSize]="atcTableControl.pageSize"
                 [pageIndex]="0" [pageSizeOptions]="atcTableControl.pageSizeOptions">
  </mat-paginator>
</div>
